<template>
    <div class="footer">
      <span>{{$t('el.d.footer_info')}}</span><br>
      <span>{{$t('el.d.footer_backup')}}</span>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue